import { Size } from '..';

/**
 * Types for the table.
 */
export interface ToggleSwitchProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onToggle' | 'onKeyDown' | 'onClick' | 'tabIndex'  >{
  /** Required. Id of the ToggleSwitch will be set to top level StyledSwitch div component. */
  id: string;
  /** Optional. Label to be shown on the right side of the toggle. */
  label?: string;
  /** Optional. If set user can not interact with Toggle. */
  disabled?: boolean;
  /** Optional. Initial state of the Toggle, defaults to 'false' */
  selected?: boolean;
  /** Optional. If set then 'critical_500' will be used as color for unselected state.*/
  isSemantic?: boolean;
  /** Optional. Defaults to 'medium' */
  size?: Size;
  /** Required. Handler to handle toggle state change. */
  onToggle: (selected: boolean) => void;
}
